import React from 'react';
import { TextInput } from 'src/tef/components/forms/TextInput';
import { ComponentVariant, IconProp } from 'src/tef/components/utils/types';

interface TextInputWithIconProps extends Omit<React.ComponentProps<typeof TextInput>, 'icon' | 'iconPosition'> {
  icon: IconProp;
  iconPosition?: 'left' | 'right';
  variant?: ComponentVariant;
}

export const TextInputWithIcon = React.forwardRef<HTMLInputElement, TextInputWithIconProps>(
  ({ icon, iconPosition = 'left', variant, ...props }, ref) => {
    return (
      <TextInput
        ref={ref}
        icon={icon}
        iconPosition={iconPosition}
        variant={variant || { style: 'withLeftIcon', size: 'md' }}
        {...props}
      />
    );
  }
);

TextInputWithIcon.displayName = 'TextInputWithIcon';
